import React from 'react'
import { useTranslation } from 'react-i18next';
import { about1, rightArrow, subMenuContact2, subMenuContact3, subMenuContact4, subMenuHome, subMenuPartners, subMenuProjects, whyUs } from '../../../assets/images';


  const newsItems = [
      {
        id: 1,
        imgSrc: subMenuHome,
        title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
        date: '15.04.2025',
      },
      {
        id: 2,
        imgSrc: subMenuPartners,
        title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
        date: '12.04.2025',
      },
      {
        id: 3,
        imgSrc: subMenuProjects,
        title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
        date: '10.04.2025',
      },
      {
          id: 4,
          imgSrc: subMenuHome,
          title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
          date: '15.04.2025',
        },
        {
          id: 5,
          imgSrc: subMenuPartners,
          title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
          date: '12.04.2025',
        },
        {
          id: 6,
          imgSrc: subMenuProjects,
          title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
          date: '10.04.2025',
        },
        {
          id: 7,
          imgSrc: subMenuHome,
          title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
          date: '15.04.2025',
        },
        {
          id: 8,
          imgSrc: subMenuPartners,
          title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
          date: '12.04.2025',
        },
        {
          id: 9,
          imgSrc: subMenuProjects,
          title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
          date: '10.04.2025',
        },
    ];

const NewsItems = () => {


      const { t } = useTranslation();

  return (
    <div className='pt-[88px] md:pt-[104px] bg-[#FBFBFB]'>
        <div className='max-w-containerSm md:max-w-container mx-auto '>
   <div className='md:flex justify-between'>
    <div className='md:w-[28%] text-[#1C1C1C]'>
 <div>
          <div className="space-y-4">
            <div>
            <div className='gap-2 flex'>
              <img className='h-6 w-6' src={subMenuContact2}></img>
              <p className='text-[18px] font-medium'>{t("Ünvan")}</p>
            </div>
            <p className='mt-2'>Babək prospekti 38a AZ1074
            Bakı/Azərbaycan</p>
            </div>
            <div>
            <div className='gap-2 flex mt-4'>
              <img className='h-6 w-6' src={subMenuContact3}></img>
              <p className='text-[18px] font-medium '>{t("E-poçt")}</p>
            </div>
            <p className='mt-2'>info@akond.az</p>
            </div>
            <div>
            <div className='gap-2 flex mt-4'>
              <img className='h-6 w-6' src={subMenuContact4}></img>
              <p className='text-[18px] font-medium'>{t("Əlaqə nömrəsi")}</p>
            </div>
            <p className='mt-2'>012 424 34 55</p>
            <p className='mt-2'>012 424 34 56</p>
            </div>
</div>
        </div>
    </div>
    <div className='md:w-[66%] mt-[56px] md:mt-0'>
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d194473.18588939894!2d49.8549596!3d40.394592499999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40307d6bd6211cf9%3A0x343f6b5e7ae56c6b!2zQmFrxLE!5e0!3m2!1saz!2saz!4v1739964667403!5m2!1saz!2saz" style={{width: window.innerWidth < 640 ? '100%' : '100%'}} height="257" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
   </div>
         <div>
           
       </div>
     
   </div>
    </div>
  )
}

export default NewsItems